/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lot_List_ExportingInputs */

const vi_lot_list_exporting = /** @type {(inputs: Lot_List_ExportingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang xuất…`)
};

/**

* @param {Lot_List_ExportingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_list_exporting = /** @type {((inputs?: Lot_List_ExportingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_List_ExportingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_list_exporting(inputs)
});